import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthenticationService } from "../services/authentication.service";
import { NgxSpinnerService } from "ngx-spinner";
import { CommonHelper } from "../../../helper/helper.component";
import { CommonConstants } from "../../../shared/constants";

@Component({
  selector: "app-admin-login",
  templateUrl: "./admin-login.component.html",
  styleUrls: ["./admin-login.component.scss"],
  styles: [
    `
      .pointer {
        cursor: pointer;
        margin-right: 5px;
        vertical-align: bottom;
      }
    `,
  ],
  providers: [AuthenticationService, CommonHelper],
})
export class AdminLoginComponent implements OnInit {
  userLoginForm: FormGroup;
  submitted = false;
  defaultLanguage: any;
  showPassword: boolean = false;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private spinner: NgxSpinnerService,
    private commonHelper: CommonHelper,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.loginValidations();
  }

  //get f() { return this.registerForm.controls; }
  get loginF() {
    return this.userLoginForm.controls;
  }

  /**loginValidations
   *
   */
  loginValidations() {
    this.userLoginForm = this.fb.group({
      emailAddress: ["", Validators.required],
      password: [
        "",
        [
          Validators.required,
          Validators.pattern(
            "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"
          ),
        ],
      ],
    });
  }

  /**login Function to call API
   *
   */
  login() {
    try {
      this.submitted = true;
      if (this.userLoginForm.invalid) {
        return;
      }

      let apiData = this.userLoginForm.value,
        data = {
          username: apiData.emailAddress,
          password: apiData.password,
        };
      this.spinner.show();
      this.authenticationService.postData("login", data).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.spinner.hide();
            console.log(response);
            //Redirecting to dashboard based on Dashboard-Role
            if (response.data.user.roleId == 1) {
              this.router.navigate(["/admin-dashboard"]);
            } else if (response.data.user.roleId == 2) {
              this.router.navigate(["/supervisor-dashboard"]);
            } else if (response.data.user.roleId == 3) {
              this.router.navigate(["/helpdesk-dashboard"]);
            } else if (response.data.user.roleId == 4) {
              this.router.navigate(["/counsellor-grievance"]);
            } else if (response.data.user.roleId == 5) {
              this.router.navigate(["/naco-dashboard"]);
            } else {
              this.router.navigate(["/level-dashboard"]);
            }

            this.storingValuesInLS(response);
          } else {
            this.spinner.hide();
            this.commonHelper.toasterMessageError(
              CommonConstants.validationMessage
            );
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (ex) {
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
  }

  /**storing values in localstorage
   *
   * @param response
   */
  storingValuesInLS(response: any) {
    let newArrayDataOfOjbect = Object.values(response.data.menu);
    localStorage.setItem("levelId", response.data.user.levelId);
    localStorage.setItem("levelName", response.data.user.levelName);
    if (newArrayDataOfOjbect.length > 0) {
      localStorage.setItem("menuData", JSON.stringify(newArrayDataOfOjbect));
    }
    localStorage.setItem("name", response.data.user.name);
    sessionStorage.setItem("stateId", response.data.user.stateId);
    localStorage.setItem("roleId", response.data.user.roleId);
    localStorage.setItem("token", response.data.access_token);
    localStorage.setItem("stateId", response.data.user.stateId);
    localStorage.getItem("language");
  }
}
